import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodDeleteCallOffAttachmentEndpointSchema } from './validations';

/**
 * Deletes a call-off attachment by its ID.
 *
 * @param callOffId - The ID of the call-off the attachment belongs to.
 * @param attachmentId - The ID of the attachment to delete.
 * @param options - Optional request options (e.g., abort signal).
 * @returns A promise that resolves when the attachment is deleted.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Call-Off/operation/delete_attachment_calloffs__calloff_id__attachments__att_id__delete
 */
export const deleteCallOffAttachment = async (
  callOffId: UUID,
  attachmentId: UUID,
  options?: KyRequestOptions,
) => {
  await vestigasApi.delete(
    ENDPOINT.CALL_OFF_ATTACHMENT.DELETE(callOffId, attachmentId),
    {
      validate: {
        pathSegments: zodDeleteCallOffAttachmentEndpointSchema,
      },
      ...options,
    },
  );
};
